import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "page-container" };
const _hoisted_2 = { class: "grid" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "p-buttonset" };
import { onBeforeMount, ref, watch } from "vue";
import { approveOrRejectAuthorizationRequest, getAuthorizationRequestsPaginated } from "@/repositories/authorization-request.repository";
import { AuthorizationRequestStatus } from "@/entities/authorization-request.entity";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
import MultiSelect from "primevue/multiselect";
import InfoIcon from "@/components/atoms/InfoIcon.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackOfficeAuthorizations',
    setup(__props) {
        const searchText = ref("");
        const authorizationRequests = ref({ items: [] });
        const pageNumber = ref(1);
        const pageSize = ref(10);
        const clearFilters = () => {
            statusValues.value = [];
            searchText.value = "";
        };
        const getStatusSeverity = (status) => {
            switch (status) {
                case "PENDING":
                    return "primary";
                case "ACCEPTED":
                    return "success";
                case "REJECTED":
                    return "warning";
                default:
                    return "primary";
            }
        };
        const getClaimTypeClass = (claimType) => {
            switch (claimType) {
                case "CAN_ACCESS_BRAND":
                    return "pi pi-shopping-cart";
                case "CAN_ACCESS_MARKET":
                    return "pi pi-globe";
                case "CAN_ACCESS_SITENAME":
                    return "pi pi-desktop";
                default:
                    return "pi pi-question";
            }
        };
        const displayApprovalButton = (status) => {
            return status === AuthorizationRequestStatus.PENDING || status === AuthorizationRequestStatus.REJECTED;
        };
        const displayRejectionButton = (status) => {
            return status === AuthorizationRequestStatus.PENDING || status === AuthorizationRequestStatus.ACCEPTED;
        };
        onBeforeMount(async () => {
            await retrieveAuthorizations();
        });
        const onSearchChange = (search) => {
            pageNumber.value = 1;
            searchText.value = search;
        };
        const approveAuthorizationRequest = async (id) => {
            await approveOrRejectAuthorizationRequest(id, true);
            await retrieveAuthorizations();
        };
        const rejectAuthorizationRequest = async (id) => {
            await approveOrRejectAuthorizationRequest(id, false);
            await retrieveAuthorizations();
        };
        const statusOptions = ref([
            { label: 'Pending', value: 'PENDING' },
            { label: 'Accepted', value: 'ACCEPTED' },
            { label: 'Rejected', value: 'REJECTED' },
        ]);
        const statusValues = ref(['PENDING']);
        watch([pageNumber, pageSize, statusValues, searchText], async () => {
            await retrieveAuthorizations();
        });
        const retrieveAuthorizations = async () => {
            authorizationRequests.value = await getAuthorizationRequestsPaginated(pageNumber.value, pageSize.value, searchText.value, statusValues.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(OneDeskCard, {
                            title: "Authorizations",
                            "has-search": true,
                            "onUpdate:searchText": _cache[2] || (_cache[2] = ($event) => (onSearchChange($event))),
                            onClearFilters: clearFilters
                        }, {
                            filters: _withCtx(() => [
                                _createVNode(_unref(MultiSelect), {
                                    maxSelectedLabels: 3,
                                    variant: "filled",
                                    display: "chip",
                                    filter: "",
                                    modelValue: statusValues.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((statusValues).value = $event)),
                                    "option-label": "label",
                                    "option-value": "value",
                                    options: statusOptions.value,
                                    placeholder: "Status"
                                }, null, 8, ["modelValue", "options"])
                            ]),
                            content: _withCtx(() => [
                                _createVNode(_unref(DataTable), {
                                    value: authorizationRequests.value.items,
                                    paginator: true,
                                    rows: pageSize.value,
                                    lazy: "",
                                    totalRecords: authorizationRequests.value.totalCount,
                                    "responsive-layout": "scroll",
                                    "removable-sort": "",
                                    first: (pageNumber.value - 1) * pageSize.value,
                                    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                    currentPageReportTemplate: "{first} to {last} of {totalRecords}",
                                    "sort-order": 1,
                                    onPage: _cache[1] || (_cache[1] = ($event) => (pageNumber.value = $event.page + 1)),
                                    "row-class": () => 'one-desk-table-row'
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Column), null, {
                                            header: _withCtx(() => [
                                                _createTextVNode("User")
                                            ]),
                                            body: _withCtx((slotProps) => [
                                                _createElementVNode("span", null, _toDisplayString(slotProps.data.userDisplayName), 1),
                                                _createVNode(InfoIcon, {
                                                    title: "Reason",
                                                    tooltip: slotProps.data.reason ?? undefined
                                                }, null, 8, ["tooltip"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(Column), {
                                            header: "Type",
                                            style: { "width": "10%" }
                                        }, {
                                            body: _withCtx((slotProps) => [
                                                _createVNode(_unref(Tag), {
                                                    severity: "secondary",
                                                    style: { "margin-right": "5px" },
                                                    icon: getClaimTypeClass(slotProps.data.claimType),
                                                    value: slotProps.data.claimValue
                                                }, null, 8, ["icon", "value"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(Column), {
                                            header: "Status",
                                            style: { "width": "10%" }
                                        }, {
                                            body: _withCtx((slotProps) => [
                                                _createVNode(_unref(Tag), {
                                                    value: slotProps.data.status,
                                                    severity: getStatusSeverity(slotProps.data.status)
                                                }, null, 8, ["value", "severity"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(Column), null, {
                                            header: _withCtx(() => [
                                                _createTextVNode("Date")
                                            ]),
                                            body: _withCtx((slotProps) => [
                                                _createVNode(_unref(Tag), {
                                                    icon: "pi pi-calendar",
                                                    value: new Date(slotProps.data.created).toLocaleDateString(),
                                                    severity: "secondary"
                                                }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(Column), null, {
                                            header: _withCtx(() => [
                                                _createTextVNode("Processed by")
                                            ]),
                                            body: _withCtx((slotProps) => [
                                                _createElementVNode("span", null, _toDisplayString(slotProps.data.approverDisplayName), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(Column), { style: { "width": "20%" } }, {
                                            header: _withCtx(() => [
                                                _createTextVNode("Actions")
                                            ]),
                                            body: _withCtx((slotProps) => [
                                                _createElementVNode("span", _hoisted_4, [
                                                    _createElementVNode("div", null, [
                                                        (displayApprovalButton(slotProps.data.status))
                                                            ? (_openBlock(), _createBlock(OneDeskButton, {
                                                                key: 0,
                                                                severity: "primary",
                                                                icon: "pi pi-check",
                                                                label: "Grant",
                                                                onClick: ($event) => (approveAuthorizationRequest(slotProps.data.id))
                                                            }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true),
                                                        (displayRejectionButton(slotProps.data.status))
                                                            ? (_openBlock(), _createBlock(OneDeskButton, {
                                                                key: 1,
                                                                severity: "warning",
                                                                icon: "pi pi-times",
                                                                onClick: ($event) => (rejectAuthorizationRequest(slotProps.data.id))
                                                            }, null, 8, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["value", "rows", "totalRecords", "first"])
                            ]),
                            _: 1
                        })
                    ])
                ])
            ]));
        };
    }
});
